<template>
  <div id="Login">
    <!-- S 最底图 -->
  <!-- <el-container> -->
    <!-- E 最底图 -->
    <!-- <el-main> -->
    <div class="loginPage">
      <div style="display: flex;width: 50vw;height: 50vh;margin: 0 auto;justify-content: center;align-items: center;">
        <!-- S 登录框左侧图-->
        <div style="flex: 1;display:flex;justify-content: flex-end;">
          <img src="../assets/index.png" style="width: 400px;height: 417.11px;">
        </div>
        <!-- E 登录框左侧图-->
        <!-- S 登录输入框-->
        <div style="flex: 1;display: flex;justify-content: flex-start;align-items: center;">
          <div class="tab login">
            <div style="padding: 20px">
              <span>
                <img src="../assets/logo.png" style="width: 60px;height: 50px;">
              </span>
              <span
                style="height:50px;font-size:25px;font-weight:bold;color:#000000;line-height:50px;letter-spacing:1px;margin-left: 20px;">
                贝壳王国
              </span>
            </div>
            <div class="tab_box">
              <div style="">
                <div class="field">
                  <img src="../assets/username.png"/>
                  <input type="text" id="username" name="username" autofocus="autofocus" class="login-text" onkeyup="this.value=this.value.replace(/\s+/g,'')" placeholder="请输入用户名"/>
                </div>
                <div class="field">
                  <img src="../assets/psrd.png"/>
                  <input type="password" id="password" name="password" class="password" placeholder="请输入密码"/>
                </div>
                <div class="movebox" style="margin-top: 20px;">
                  <div class="movego"></div>
                  <div class="txt" id="txt">拖动滑块登录</div>
                  <div class="move moveBefore" v-move="_self" id="moveDiv"></div>
                </div>
                <p style="font-size: 14px;padding-top: 45px;">河北省秦皇岛市北戴河新区戴河大街888号</p>
              </div>
            </div>
          </div>
        </div>
        <!-- E 登录输入框-->
        
      </div>
      
    </div>
    <!-- </el-main> -->
    <el-footer><a href="javascript:window.open('https://beian.miit.gov.cn');">冀ICP备 20017309号-1</a></el-footer>
  <!-- </el-container> -->
  </div>
</template>

<script>
  export default {
    name: "Login",
    data() {
      return {
        username: "",
        password: "",
        _self: this
      };
    },
    methods: {
      getCodeList: function () {
        this.$axios.get("/code/getCodeList").then(data => {
          var res = data.data;
          var len = res.length - 1;
          var tempType = res[0].type;
          var list = {};
          var temp = [];
          res.forEach(function (e, index) {
            if (e.type == tempType) {
              temp.push({code: e.code, value: e.value});
              if (index == len) {
                list[tempType] = temp;
              }
            } else {
              list[tempType] = temp;
              temp = [];
              temp.push({code: e.code, value: e.value});
            }
            tempType = e.type;
          });
          window.localStorage.setItem(this.GLOBAL.SYS_CODE, JSON.stringify(list));
        });
      }
    },
    directives: {
      move(el, binding) {
        el.onmousedown = function (e) {
          var X = e.clientX - el.offsetLeft;
          document.onmousemove = function (e) {
            var endx = e.clientX - X;
            el.className = "move moveBefore";
            el.style.left = endx + "px";
            var width = $(".movebox").width() - $(".move").width();
            el.parentNode.children[0].style.width = endx + "px";
            el.parentNode.children[1].innerHTML = "拖动滑块登录";
            //临界值小于
            if (endx <= 0) {
              el.style.left = 0 + "px";
              el.parentNode.children[0].style.width = 0 + "px";
              el.style.left = "0px";
              $(".movego").width(0);
            }
            //临界值大于
            // console.log(el.style.left)
            if (parseInt(el.style.left) >= width) {
              el.style.left = Math.ceil(width) + "px";
              el.parentNode.children[0].style.width = width + "px";
              // el.parentNode.children[1].innerHTML = '正在登录...';
              // el.className = 'move moveSuccess';
              // el.onmousedown = null;
            }
          };
        };
        document.onmouseup = function (e) {
          var X = e.clientX - el.offsetLeft;
          var endx = e.clientX - X;
          var width = $(".movebox").width() - $(".move").width();
          if (endx >= width) {
            var username = $("#username").val();
            var password = $("#password").val();
            if (username == "" || username == null) {
              binding.value.$message({
                message: "用户名不能为空",
                type: "error"
              });
              el.style.left = "0px";
              $(".movego").width(0);
              $("#username").focus();
            } else if (password == "" || password == null) {
              binding.value.$message({
                message: "密码不能为空",
                type: "error"
              });
              el.style.left = "0px";
              $(".movego").width(0);
              $("#password").focus();
            } else {
              el.parentNode.children[1].innerHTML = "正在登录...";
              el.className = "move moveSuccess";
              binding.value.$axios
                .post("/user/login", {username: username, password: password})
                .then(data => {
                  if (data.code == "0000") {
                    var res = data.data;
                    var initPassword = 0;
                    if(password == '888888'){
                      initPassword = 1;
                    }
                    var user = {
                      userId: res.userId,
                      username: res.username,
                      realName: res.realName,
                      sex: res.sex,
                      initPassword: initPassword,
                      deptName: res.deptName,
                      deptId: res.deptId,
                      mobile: res.mobile,
                      tel: res.tel,
                      jqId: res.jqId
                    };
                    window.localStorage.setItem(
                      binding.value.GLOBAL.USER_TOKEN,
                      res.accessToken
                    );
                    window.localStorage.setItem(
                      binding.value.GLOBAL.USER_INFO,
                      JSON.stringify(user)
                    );
                    var auth = "#,/home";
                    var authButtonList = [];
                    var menuList = [];
                    res.menu.forEach(function (e) {
                      if (e.isShow == 1) {
                        menuList.push(e)
                        if (e.url != "#") {
                          auth += "," + e.url;
                        }
                      } else {
                        authButtonList.push(e.url)
                      }

                    });
                    window.localStorage.setItem(
                      binding.value.GLOBAL.USER_AUTH,
                      auth
                    );
                    window.localStorage.setItem(
                      binding.value.GLOBAL.USER_MENU,
                      JSON.stringify(menuList)
                    );
                    window.localStorage.setItem(
                      binding.value.GLOBAL.USER_AUTH_BUTTOM,
                      authButtonList.join(',')
                    );
                    binding.value.$router.push("/home");
                    binding.value.getCodeList();
                  } else {
                    document.getElementById("moveDiv").click();
                    binding.value.$message({
                      message: data.message,
                      type: "error"
                    });
                    el.parentNode.children[1].innerHTML = "拖动滑块登录";
                    el.className = "move moveBefore";
                    el.style.left = "0px";
                    $(".movego").width(0);
                    $("#username").focus();
                  }
                })
                .catch(function (error) {
                  binding.value.$message({
                    message: "请检查您的计算机时间是否与互联网时间保持一致！",
                    type: "error"
                  });
                  el.parentNode.children[1].innerHTML = "拖动滑块登录";
                  el.className = "move moveBefore";
                  el.style.left = "0px";
                  $(".movego").width(0);
                  $("#username").focus();
                });
            }
          } else {
            el.style.left = "0px";
            $(".movego").width(0);
          }
          //document.getElementById("moveDiv").click();
          document.onmousemove = null;
        };
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*公共样式--开始*/
  html,
  body,
  div,
  ul,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  dl,
  dt,
  dd,
  ol,
  form,
  input,
  textarea,
  th,
  td,
  select {
    margin: 0;
    padding: 0;
  }

  * {
    box-sizing: border-box;
  }

  html,
  body {
    min-height: 100%;
  }

  body {
    font-family: "Microsoft YaHei";
    font-size: 14px;
    color: #000000;
    overflow-x: hidden;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
  }

  ul,
  ol {
    list-style: none;
  }

  img {
    border: none;
    vertical-align: middle;
  }

  a {
    text-decoration: none;
    color: #232323;
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  input,
  textarea {
    outline: none;
    border: none;
  }

  textarea {
    resize: none;
    overflow: auto;
  }

  .header {
    width: 100%;
    height: 95px;
    text-align: center;
    background: url(../assets/header-c.png) left top;
  }


  .header-c div.fr {
    margin: 30px 0 0 0;
  }

  .header-c div.fr span {
    color: #000000;
    display: inline-block;
  }

  .header-c div.fr a {
    color: #000000;
    padding: 5px 20px;
    border: 1px solid #dddddd;
    display: inline-block;
    margin: 0 5px;
    border-radius: 5px;
  }

  .header-c div.fr a:hover {
    border: 1px solid #087de7;
    color: #087de7;
  }

  .loginPage {
    width: 100vw;
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-image: url(../assets/indexbg.jpg); */
    background-repeat: no-repeat;
    background-position: 0px 8vh;
    background-size: 100%;
  }

  .footer-c span {
    margin: 10px auto;
    color: #5b5b5d;
    font-size: 14px;
    display: block;
    text-align: center;
  }

  .field {
    width: 100%;
    height: 40px;
    margin: 35px 0px;
  }

  .field label {
    width: 60px;
    height: 40px;
    line-height: 40px;
    float: left;
    text-align: right;
    padding-right: 5px;
    font-size: 15px;
    font-weight: 700;
    /* font-family:"微软雅黑"; */
  }

  .field input.login-text,
  .field input.password {
    width: 340px;
    height: 40px;
    line-height: 40px;
    float: right;
    border: 1px solid #dddddd;
    font-size: 14px;
    padding-left: 5px;
  }

  .field input.yzm {
    width: 180px;
    height: 40px;
    line-height: 40px;
    float: left;
    border: 1px solid #dddddd;
    font-size: 14px;
    padding-left: 5px;
  }

  .field a.hqyzm {
    width: 150px;
    height: 40px;
    line-height: 40px;
    float: right;
    border: 1px solid #dddddd;
  }

  .field a.hqyzm:hover {
    color: #087de7;
  }

  .yhxy {
    padding-left: 30px;
  }

  .yhxy a {
    color: #087de7;
  }

  .register {
    width: 100%;
    height: 40px;
    margin-top: 30px;
  }

  .register button {
    width: 340px;
    height: 40px;
    background: #3c1797;
    text-align: center;
    color: #ffffff;
    font-size: 17px;
    font-weight: 500;
    border: 0;
    float: right;
    border-radius: 3px;
  }

  .register button:hover {
    background: #381789;
    cursor: pointer;
  }

  .login {
    padding: 24px 50px;
    /*border: 1px solid #cccccc;*/
    background: #ffffff;
    height: 417px;
    box-shadow: 0px 3px 11px 0px rgba(0, 0, 0, 0.1);
  }

  .login .field {
    position: relative;
  }

  .login .field input.login-text,
  .login .field input.password,
  .login .register button {
    width: 300px;
  }

  .login .field input.login-text,
  .login .field input.password {
    padding-left: 55px;
  }

  .login .field img {
    width: 50px;
    height: 38px;
    position: absolute;
    left: 1px;
    top: 1px;
    z-index: 9;
  }

  .hide {
    display: none;
  }

  .tab_menu {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #cccccc;
  }

  .tab_menu ul li {
    width: 26%;
    height: 50px;
    line-height: 50px;
    float: left;
    text-align: center;
    font-size: 17px;
    font-weight: 700;
    margin-right: 20px;
    color: #797878;
  }

  .tab_menu ul li:hover {
    cursor: pointer;
    color: #087de7;
  }

  .selected {
    border-bottom: 4px solid #087de7;
  }

  .loginbg {
    background: url(../assets/indexbg.jpg) no-repeat center center;
    background-size: 100%;
    height: 60%;
    width: 100%;
    min-height: 400px;
  }

  html,
  body {
    width: 100%;
    height: 100%;
  }

  .loginbg .main-c {
    width: 380px;
    height: 100%;
    position: relative;
  }

  .bg-no {
    height: 17%;
  }

  .bg-no .logo-login {
    margin-top: 0;
  }

  .bg-no .logo-login img {
    margin-top: 180%;
    margin-left: 690%;
  }

  .bg-no .header-c {
    height: 100%;
  }

  .movebox {
    position: relative;
    background-color: #e8e8e8;
    width: 300px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #dddddd;
  }

  .txt {
    position: absolute;
    top: 0px;
    width: 300px;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
  }

  .movego {
    background-color: #4395ee;
    height: 38px;
    width: 0px;
  }

  .move {
    position: absolute;
    bottom: 0px;
    top: 0px;
    left: 0px;

    width: 50px;
    height: 38px;
    border: 0px solid #ccc;
    cursor: move;
  }

  .moveBefore {
    background: #75cdf9 url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
  }

  .moveSuccess {
    background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue